const declentionsMap = {
    'course': ['курс', 'курса', 'курсов'],
    'paragraph': ['тема', 'темы', 'тем'],
    'points': ['балл', 'балла', 'баллов']
}

export default declentionsMap